<div
  class="widget-card-small"
  [class.selected]="isSelected$ | async"
  [class.section-heading]="
    widget.widget_type_id === widgetTypes.WIDGET_TYPE_SECTION_BREAK
  "
  [class.has-header-color]="!!widget.settings?.widget_header_color"
  [style.--widget-header-bg]="widget.settings?.widget_header_color || null"
  [style.--widget-header-fg]="headerTextColor"
  [attr.data-widget-id]="widget.id"
>
  <div class="drag-handle" [class.disabled]="searchString?.length > 0">
    <fa-icon [icon]="['fas', 'arrows-up-down']"></fa-icon>
  </div>
  <div class="select-tool">
    <div class="select-section-wrapper">
      @if (
        widget.chart_type.widget_type_id ===
        widgetTypes.WIDGET_TYPE_SECTION_BREAK
      ) {
        <sui-checkbox
          class="select-section-heading"
          [checked]="isSelected$ | async"
          (checkedChange)="selectSectionHeading(widget)"
        ></sui-checkbox>
      }
    </div>
    <sui-checkbox
      [checked]="isSelected$ | async"
      (checkedChange)="objectActionService?.toggleObjectSelection(widget)"
    ></sui-checkbox>
  </div>
  <div class="language-tool">
    <div class="current-language">
      {{ "widget-card-list.label.default" | translate }}
    </div>
  </div>
  <div class="input-title">
    <sui-input
      type="text"
      [placeholder]="'widget-card-list.placeholder.title' | translate"
      [(ngModel)]="widgetTitle"
      (focusout)="onTitleBlur()"
    ></sui-input>
  </div>
  <div class="language-tool">
    <div class="current-language">
      {{
        currentLanguage
          ? currentLanguage
          : ("widget-card-list.label.english" | translate)
      }}
    </div>
  </div>
  <div class="input-title">
    <sui-input
      type="text"
      [(ngModel)]="exportWidgetTitle"
      (focusout)="onExportTitleBlur()"
    ></sui-input>
  </div>
  <div class="tools">
    <div class="tool page-break">
      <label
        sui-label
        [suiTooltip]="
          'widget.settings-output.label.page-break-before' | translate
        "
        >pb:</label
      >
      <sui-checkbox
        [checked]="widget.settings.section_break_page_break_before"
        (checkedChange)="
          updatePageBreak(widget.settings.section_break_page_break_before)
        "
      ></sui-checkbox>
    </div>
    <div
      class="tool settings"
      [suiTooltip]="'widget-card-list.tooltip.settings' | translate"
    >
      <fa-icon [icon]="faGear" (click)="editWidget(widget)"></fa-icon>
    </div>

    <div
      class="tool datasources"
      [suiTooltip]="
        translateService.instant('widget-card-list.tooltip.datasources') +
        ': ' +
        widget.datasources.length
      "
      (click)="configureDatasource()"
    >
      <fa-icon [icon]="['fas', 'database']"></fa-icon>
      <span>{{ widget.datasources.length }}</span>
    </div>

    <div
      class="tool filters"
      [suiTooltip]="
        translateService.instant('widget-card-list.tooltip.filter-dimensions') +
        ': ' +
        widget.dimensions_filter.length
      "
      (click)="configureFilters()"
    >
      <fa-icon [icon]="['fas', 'filter']"></fa-icon>
      <span>{{ widget.dimensions_filter.length }}</span>
    </div>

    <div
      class="tool pivot-dimensions"
      [suiTooltip]="
        translateService.instant('widget-card-list.tooltip.pivot-dimensions') +
        ': ' +
        widget.dimensions_pivot.length
      "
      (click)="configurePivots()"
    >
      <fa-icon [icon]="['fas', 'layer-group']"></fa-icon>
      <span>{{ widget.dimensions_pivot.length }}</span>
    </div>

    @if (widget.settings?.override_output_settings ?? false) {
      <div
        class="tool override-output-settings"
        [suiTooltip]="
          translateService.instant(
            'widget-card-list.tooltip.override-output-settings'
          ) +
          ': ' +
          ((widget.settings?.override_output_settings ?? false)
            ? translateService.instant('forms.form-option.yes')
            : translateService.instant('forms.form-option.no'))
        "
      >
        <fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon>
        <span>{{ "OOS" }}</span>
      </div>
    }

    <div
      class="tool copy"
      [suiTooltip]="
        translateService.instant('widget-card-list.tooltip.duplicate-widget')
      "
      (click)="duplicateWidget()"
    >
      <fa-icon [icon]="['fas', 'copy']"></fa-icon>
    </div>

    <div class="tool delete" (click)="deleteWidget()">
      <fa-icon [icon]="['fas', 'times-circle']"></fa-icon>
    </div>
  </div>
</div>
